import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { ROUTES } from "../constants";

@Injectable()
export class UtilityService {

	constructor(
		private router: Router,
		private cookieService: CookieService
	) { }
	/**
	 *	Navigate to the specified path
	 * @param routeName : path string
	 */
	navigate( routeName: string, queryParams?: object ): Promise<boolean> {
		return this.router.navigate( [ routeName ], queryParams ? queryParams : {} );
	}

	/**
	 * Navigate to Login page
	 */
	redirectToLoginPage(): void {
		this.navigate( ROUTES.LOG_IN );
	}

	redirect(route) {
		this.navigate(route);
	}

	/**
	 * Navigate to register/signup page
	 */
	redirectToRegisterPage(): void {
		this.navigate( ROUTES.SIGN_UP );
	}

	/**
	 * Navigate to buyer dashboard page
	 */
	redirectToDashboardPage(): void {
		this.navigate( ROUTES.BUYER_ROUTE + "/" + ROUTES.OVERVIEW );
	}

	/**
	 * Navigate to buyer dashboard page
	 */
	redirectToTendersPage(): void {
		this.navigate( ROUTES.BUYER_ROUTE + "/" + ROUTES.TENDERS );
	}

	/**
	 * Navigate to supplier dashboard page
	 */
	redirectToSupplierDashboardPage(): void {
		this.navigate( ROUTES.SUPPLIER_ROUTE + "/" + ROUTES.OVERVIEW );
	}

	/**
	 * Navigate to supplier dashboard page
	 */
	redirectToSupplierTenderPage(): void {
		this.navigate( ROUTES.SUPPLIER_ROUTE + ROUTES.SUPPLIER_TENDERS_ROUTE );
	}

	/**
	 * Extract parameter value by key from url.
	 * @param url: url string
	 * @param key: parameter key
	 */
	getParamsFromUrl( url: string, key: string ): string {
		const urlParams = url.split( "?" )[1];
		const urlString = new URLSearchParams( urlParams );
		return urlString.get( key );
	}

	/**
	 * Extract parameter value by key from encoded url.
	 * @param url: url string
	 */
	getParamsFromEncodedUrl( url: string ): Object {
		const urlParams = url.split( "?" )[1];
		const queryParams: object = {};
		decodeURIComponent( urlParams ).split( "&" ).forEach( ( query ) => {
			const chunks = query.split( "=" );
			queryParams[chunks[0]] = chunks[1];
		} );
		return queryParams;
	}

	/**
	 * Clear localStorage and cookies if existed
	 */
	clearStorageAndCookies(): void {
		this.cookieService.deleteAll( "/" );
		localStorage.removeItem( "token" );
	}

	/**
	 * Get parsed value from local storage
	 * @param key : key to get data from local storage
	 */
	getFromLocalStorage( key: string ) {
		return JSON.parse( localStorage.getItem( key ) );
	}

	/**
	 * Set stringified value by key in local storage
	 */
	setToLocalStorage( key: string, value: any ): void {
		return localStorage.setItem( key, JSON.stringify( value ) );
	}

	/**
	 * Set stringified value by key in local storage
	 */
	deleteFromLocalStorage( key: string ): void {
		return localStorage.removeItem( key );
	}

	/**
	 * Get parsed value from session storage
	 * @param key : key to get data from session storage
	 */
	getFromSessionStorage( key: string ) {
		if( sessionStorage.getItem( key ) !== "undefined" ){
			return JSON.parse( sessionStorage.getItem( key ) );
		} else {
			return [];
		}
	}

	/**
	 * Set stringified value by key in session storage
	 */
	setToSessionStorage( key: string, value: any ): void {
		return sessionStorage.setItem( key, JSON.stringify( value ) );
	}

	/**
	 * Set stringified value by key in session storage
	 */
	deleteFromSessionStorage( key: string ): void {
		return sessionStorage.removeItem( key );
	}

	/**
	 * Group Array of object by specific object key
	 */
	groupArrayObject( array, key ) {
		if ( array?.length ) {
			return array.reduce( ( reducedArray, data ) => {
				let value = key instanceof Function ? key( data ) : data[key];
				let element = reducedArray.find( ( item ) => item && item.key === value );
				if ( element ) {
					element.values.push( data );
				} else {
					reducedArray.push( { key: value, values: [ data ] } );
				} return reducedArray;
			}, [] );
		}
		return [];
	}

	/**
	 *
	 * @param sortingFields : Array of sorting fields
	 * @returns
	 */
	getSortingFields( sortingFields: Array<object> ): { column: string, direction: "asc" | "desc" } {
		const sortingField = sortingFields.filter( field => field["value"] );
		return sortingField.length ? { column: sortingField[0]["key"], direction: sortingField[0]["value"] === "ascend" ? "asc" : "desc" } : { column: "createdAt", direction: "desc" };
	}

	/**
	 * Generate 12 digit random number
	 * @returns : number
	 */
	generateRandomNumber(): number {
		return Math.random() * ( 10^12 );
	}

	calculateTotalPrice( priceUnit: number, volume: number, pricePerPriceUnit: number ): number {
		return ( pricePerPriceUnit * volume ) / priceUnit;
	}

	calculatePricePerUnit( pricePerPriceUnit?: number, price?: number, priceUnit?: number ): number {
		if( !pricePerPriceUnit ) {
			return price;
		}
		return ( pricePerPriceUnit ) / ( priceUnit || 1 );
	}
}
